import { useSearch } from '@tanstack/react-router';

import { useRole } from '../../common/hooks/useRole';

export const useVesselOverviewFilters = () => {
    const search = useSearch({ from: '/_app/vessels' });
    const role = useRole();
    const fallbackCustomerIds = role.isSuperAdmin() ? undefined : role.getCompanies().map((company) => company.id);
    const customerIds = search.customerIds.length ? search.customerIds : fallbackCustomerIds;

    return {
        searchQuery: search.searchQuery,
        customerIds,
        defaultSupplierIds: search.defaultSupplierIds,
    };
};
